import React, { useState, useEffect } from 'react';
import TablePager from 'shared_components/table_pager';
import { Row, Col, Icon, Table, Input, Button, Drawer, Select, Divider } from 'antd';
import fetchItems, { fetchItemsperQuestionTypes } from 'services/blood_bank/question_type';

import QuestionTable from '../form';
import { tableSize } from '../settings';

const { Search } = Input;
const { Option } = Select;
const columns = [
	{
		title: 'CATEGORY ID',
		dataIndex: '',
		width: 150,
	},
	{
		title: 'CATERORY NAME',
		dataIndex: '',
		width: 200,
	},
	{
		title: 'DESCRIPTION',
		dataIndex: '',
		width: 400,
	},
	{
		title: 'SEQUENCE',
		dataIndex: '',
		width: 150,
	},
	{
		title: 'STATUS',
		dataIndex: '',
		fixed: 'right',
		width: 150,
	},
];

const QuestionCategory = () => {
	const [visible, setVisible] = useState(false);
	const [loading, setLoading] = useState(false);
	const [pagination, setPagination] = useState({});

	const [actionType, setActionType] = useState('add');
	const [drawerTitle, setDrawerTitle] = useState('');
	const [drawerButton, setDrawerButton] = useState('');
	const [addButtonDisable, setAddButtonDisable] = useState(true);
	const [QuestionnareItem, setQuestionnareItem] = useState([]);
	const [questionTypeList, setQuestionTypeList] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState({});
	const [selectQuestionType, setSelectQuestionType] = useState(null);

	useEffect(() => {
		const fetchQuestionTypeList = async () => {
			const questionTypeList = await fetchItems();
			console.log('Question type list:', questionTypeList);
			setQuestionTypeList(questionTypeList);
		};

		fetchQuestionTypeList();
	}, []);

	const onChange = async value => {
		console.log(value);
		const perQuestionTypesData = await fetchItemsperQuestionTypes(value);

		if (perQuestionTypesData.length !== 0) {
			console.log('perQuestionTypesData:', perQuestionTypesData.data);
			setSelectQuestionType(value[1]);
			setQuestionnareItem(perQuestionTypesData.data);
			setAddButtonDisable(false);
		}
	};

	const showDrawer = record => {
		setVisible(true);
		setDrawerTitle('ADD QUESTION');
		setDrawerButton('ADD');
		setActionType('add');
		setSelectedCategories(record);
	};

	const onClose = () => {
		setVisible(false);
	};

	const displayDrawerUpdate = record => {
		console.log(record);

		setVisible(true);
		setDrawerTitle('UPDATE QUESTION');
		setDrawerButton('UPDATE');
		setActionType('update');
		setSelectedCategories(record);
	};

	const onSearch = value => {
		const searchedVal = value.toLowerCase();
		const filtered = QuestionnareItem.filter(item => {
			const { question_order } = item;
			return containsString(question_order, searchedVal);
		});
		setQuestionnareItem(filtered);
	};

	const containsString = (searchFrom, searchedVal) => {
		if (searchFrom === null || searchFrom === '') return false;
		return searchFrom
			.toString()
			.toLowerCase()
			.includes(searchedVal);
	};

	const handlePagerChange = value => {
		console.log(value);
		// const newPagination = { ...pagination };
		// newPagination.pageSize = parseInt(value);
		setPagination(value);
	};

	const questionTypeOption = questionTypeList.map((item, i) => (
		<Option key={i} value={item.ques_type_name}>
			{item.ques_type_name}
		</Option>
	));

	return (
		<div>
			<div className="settings-user-table-action">
				<Row>
					<Col span={12}>
						<Search
							allowClear
							onSearch={value => onSearch(value)}
							style={{ width: 200 }}
							className="panel-table-search-input"
						/>
					</Col>
					<Col span={12} style={{ textAlign: 'right' }}>
						<Button
							// disabled={addButtonDisable}
							type="primary"
							shape="round"
							style={{ marginRight: '15px' }}
						>
							APPLY SORTING
						</Button>
						<Button
							// disabled={addButtonDisable}
							type="primary"
							shape="round"
							style={{ marginRight: '15px' }}
							onClick={showDrawer}
						>
							<Icon type="plus" /> ADD QUESTIONNAIRE
						</Button>
						<TablePager handleChange={handlePagerChange} />
					</Col>
				</Row>
			</div>
			<div className="settings-user-table">
				<Table
					dataSource={QuestionnareItem}
					loading={loading}
					size={tableSize}
					columns={columns}
					pagination={pagination}
					rowKey={record => record.userID}
					onRow={record => {
						return {
							onDoubleClick: () => {
								// const data = { ...record };
								displayDrawerUpdate(record);
							},
						};
					}}
				/>
			</div>
			<Drawer title={drawerTitle} width="30%" visible={visible} onClose={onClose} destroyOnClose>
				<QuestionTable
					selectedCategories={selectedCategories}
					actionType={actionType}
					drawerButton={drawerButton}
					selectQuestionType={selectQuestionType}
				/>
			</Drawer>
		</div>
	);
};

export default QuestionCategory;
